'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('./internal/_get');

var _get3 = _interopRequireDefault(_get2);

var _map2 = require('./internal/_map');

var _map3 = _interopRequireDefault(_map2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pluck(key, subject) {
  return (0, _map3.default)(function (item) {
    return (0, _get3.default)(key, item);
  }, subject);
}

/**
 * Select `key` from each item in `subject`.
 *
 * @example
 * const pluckName = pluck('name');
 * pluckName(userMap) === Map({123: 'Testing'});
 *
 * @param  {any} key
 * @param  {Iterable} subject
 * @return {Iterable}
 */
exports.default = (0, _curry2.default)(pluck);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/pluck.js
// module id = 383
// module chunks = 0 1